<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('renouvellementCommande.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('renouvellementCommande.filtre.sousTitle') }}
        </span>
      </div>
      <div class="column is-12" v-if="hasError">
        <error-msg-component :messages="errors"
                             :error="hasError"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="closeErrorMsg"/>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
         :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="critereRecherche.dates"
            :label="$t('renouvellementCommande.filtre.periode')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('renouvellementCommande.filtre.parDateDe')">
            <b-select v-model="critereRecherche.optionDate" expanded>
              <option></option>
              <option v-for="choix in constantes.DATES_FILTRE_CHOIX"
                      :key="choix.code"
                      :value="choix.code">
                {{ $t(choix.libelle) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('renouvellementCommande.filtre.numeroCommande')">
            <b-input v-model="critereRecherche.code">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('renouvellementCommande.filtre.code')">
            <b-input v-model="critereRecherche.codeDossier">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('renouvellementCommande.filtre.theme')">
            <qd-taginput v-model="critereRecherche.themes"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                      :label="$t('renouvellementCommande.filtre.etat')"
                      :items="constantes.LISTE_ETAT_RENOUVELLEMENT"
                      v-model="listeEtatSelectionne">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-client-tag-input
            v-model="payeursSelected"
            :label="$t('renouvellementCommande.filtre.payeur')"
            :societeActiveId="societeActiveId">
          </query-client-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-client-tag-input
            v-model="annonceursSelected"
            :label="$t('renouvellementCommande.filtre.annonceur')"
            :societeActiveId="societeActiveId">
          </query-client-tag-input>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
                        :label="$t('renouvellementCommande.filtre.commercial')"
                        :blocked="userIsCommercialBlocked"
                        v-model="commercialSelected"
                        :items="listeCommercial">
          </user-tag-input>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
                        :label="$t('renouvellementCommande.filtre.assistant')"
                        v-model="assistantSelected"
                        :items="listeAssistant">
          </user-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <agence-tag-input
                      :label="$t('renouvellementCommande.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="critereRecherche.agencesId">
          </agence-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tag-input :label="$t('renouvellementCommande.filtre.tags')"
            v-model="critereRecherche.tagIds"
            :query="(search) => getAllTags({
              query:
              {
                auto: search,
                actif: true,
                moduleTag: constantes.DOCUMENT_VENTE,
              },
            })">
            <template slot-scope="props">
              {{ props.option.libelle }}
            </template>
          </query-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            :label="$t('renouvellementCommande.filtre.groupe')"
            dropdown="top"
            v-model="groupeSelected"
            :typologie="this.constantes.TYPOLOGIE_GROUPE"
            :societeActiveId="this.societeActiveId">
          </query-tiers-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            :label="$t('renouvellementCommande.filtre.enseigne')"
            dropdown="top"
            v-model="enseigneSelected"
            :typologie="this.constantes.TYPOLOGIE_ENSEIGNE"
            :societeActiveId="this.societeActiveId">
          </query-tiers-tag-input>
        </div>
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="critereRecherche.dateCampagne"
            :label="$t('renouvellementCommande.filtre.dateCampagne')">
         </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('renouvellementCommande.filtre.reconductible')">
            <b-select v-model="critereRecherche.reconductible" expanded>
              <option :value="null"></option>
              <option :value="true">{{ $t('general.oui') }}</option>
              <option :value="false">{{ $t('general.non') }}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('renouvellementCommande.filtre.interne')">
            <b-select v-model="critereRecherche.interne" expanded>
              <option :value="null"></option>
              <option :value="true">{{ $t('general.oui') }}</option>
              <option :value="false">{{ $t('general.non') }}</option>
           </b-select>
         </b-field>
       </div>
       <div class="column is-12 pdb-0">
          <b-field :label="$t('renouvellementCommande.filtre.estSigne')">
            <b-select v-model="critereRecherche.estSigne" expanded>
              <option :value="null"></option>
              <option :value="true">{{ $t('general.oui') }}</option>
              <option :value="false">{{ $t('general.non') }}</option>
            </b-select>
         </b-field>
       </div>
       <div class="column is-12 pdb-0" v-if="moduleSignatureElectroniqueActive">
          <b-field :label="$t('renouvellementCommande.filtre.estSigneElectroniquement')">
            <b-select v-model="critereRecherche.estSigneElectroniquement" expanded>
              <option :value="null"></option>
              <option :value="true">{{ $t('general.oui') }}</option>
              <option :value="false">{{ $t('general.non') }}</option>
            </b-select>
         </b-field>
       </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('renouvellementCommande.filtre.actions.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('renouvellementCommande.filtre.actions.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { LISTE_ETAT_RENOUVELLEMENT } from '@/configuration/devisConf';
import messageErreur from '@/services/general/messageErreur';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { ASSISTANT_COMMERCIAL, COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import { SET_CRITERE } from '@/store/modules/renouvellementCommande-mutation-type';
import genererCriteresRechercheRenouvellementCommande
  from '@/services/commande/criteresRecherche/genererCriteresRechercheRenouvellementCommande';
import { DATES_FILTRE_CHOIX } from '@/configuration/commande/commandeConf';
import validationFiltreRenouvellement from '@/services/commande/renouvellement/validationFiltreRenouvellement';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import {
  TYPOLOGIE_ENSEIGNE, TYPOLOGIE_GROUPE,
} from '@/configuration/tiers/tiersConf';
import queryClientTagInput from '@/components/general/tagInput/queryClientTagInput';
import queryTiersTagInput from '@/components/general/tagInput/queryTiersTagInput';
import userTagInput from '@/components/general/tagInput/userTagInput';
import initialUsers from '@/services/general/filters/filterinitUsers';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import inputPeriode from '@/components/general/inputPeriode';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import queryTagInput from '@/components/general/tagInput/queryTagInput';
import { DOCUMENT_VENTE } from '@/configuration/parametrage/tagConf';
import { getAll as getAllTags } from '@/api/tag/index';

const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');
const RenouvellementCommande = createNamespacedHelpers('renouvellementCommande');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      critereRecherche: null,
      listeEtatSelectionne: [],
      commercialSelected: [],
      listeCommercial: [],
      assistantSelected: [],
      listeAssistant: [],
      constantes: {
        DATES_FILTRE_CHOIX,
        TYPOLOGIE_ENSEIGNE,
        TYPOLOGIE_GROUPE,
        LISTE_ETAT_RENOUVELLEMENT,
        DOCUMENT_VENTE,
      },
      hasError: false,
      errors: [],
      groupeSelected: [],
      enseigneSelected: [],
      annonceursSelected: [],
      filteredAnnonceurs: [],
      payeursSelected: [],
      getAllTags,
    };
  },
  components: {
    userTagInput,
    queryTiersTagInput,
    agenceTagInput,
    libelleTagInput,
    errorMsgComponent,
    queryClientTagInput,
    inputPeriode,
    queryTagInput,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      societeActive: 'societeActive',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...RenouvellementCommande.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    blocageFiltreCommercial() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercial() {
      return this.user.profil === COMMERCIAL;
    },
    userIsCommercialBlocked() {
      return (this.userIsCommercial && this.blocageFiltreCommercial);
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
      );
    },
    medialinePlanningLCRenouvellement() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.medialinePlanningLCRenouvellement.key);
    },
    moduleSignatureElectroniqueActive() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.signatureElectronique.key);
    },
  },
  methods: {
    ...RenouvellementCommande.mapMutations({
      setCritereRecheche: SET_CRITERE,
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    closeErrorMsg() {
      this.errors = [];
      this.hasError = false;
    },
    async viderCritere() {
      this.critereRecherche = genererCriteresRechercheRenouvellementCommande(
        this.medialinePlanningLCRenouvellement);
      await updateCritereWithParametreInterne(this.critereRecherche);
      this.commercialSelected = this.critereRecherche.commercialId.map(id => {
        return this.listeCommercial.find(c => c.id === id) ?? {};
      });
      this.assistantSelected = this.critereRecherche.assistantIds.map(id => {
        return this.listeAssistant.find(c => c.id === id) ?? {};
      });
      if (this.medialinePlanningLCRenouvellement) {
        this.listeEtatSelectionne = LISTE_ETAT_RENOUVELLEMENT.filter((etat) => {
          etat.libelleI18n = this.$t(etat.libelle);
          return this.critereRecherche.etatsRenouvellement.includes(etat.code);
        });
      } else {
        this.listeEtatSelectionne = [];
      }
      this.groupeSelected = [];
      this.enseigneSelected = [];
      this.payeursSelected = [];
      this.annonceursSelected = [];
    },
    appliquerCritere() {
      this.errors = [];
      this.hasError = validationFiltreRenouvellement(
        this.critereRecherche.optionDate, this.critereRecherche.dates, this.errors,
      );
      if (this.hasError) return;
      if (this.listeEtatSelectionne) {
        this.critereRecherche.etatsRenouvellement = this.listeEtatSelectionne.map((etat) => {
          return etat.code;
        });
      }
      this.critereRecherche.commercialId = this.commercialSelected.map((c) => {
        return c.id;
      });
      this.critereRecherche.assistantIds = this.assistantSelected.map((c) => {
        return c.id;
      });
      this.critereRecherche.groupeIds = this.groupeSelected;
      this.critereRecherche.enseigneIds = this.enseigneSelected;
      this.critereRecherche.payeurs = this.payeursSelected;
      this.critereRecherche.annonceurs = this.annonceursSelected;
      this.setCritereRecheche(this.critereRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
        await this.loadParametreUtilisateur();
        if (this.critereRecherche.etatsRenouvellement) {
          this.listeEtatSelectionne = LISTE_ETAT_RENOUVELLEMENT.filter((etat) => {
            etat.libelleI18n = this.$t(etat.libelle);
            return this.critereRecherche.etatsRenouvellement.includes(etat.code);
          });
        }
        const users = this.parametre(typesParametres.PARAMETRES_KEYS.utilisateur)
          .filter(u => u.actif);
        this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL], this.$i18n.t('listeDevis.filtre.noCommercial'));
        this.listeAssistant = initialUsers(users, [ASSISTANT_COMMERCIAL], this.$i18n.t('listeDevis.filtre.sansAssistant'));

        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.critereRecherche.commercialId.includes(c.id);
        });
        this.assistantSelected = this.listeAssistant.filter((c) => {
          return this.critereRecherche.assistantIds.includes(c.id);
        });
        this.enseigneSelected = this.critereRecherche.enseigneIds;
        this.groupeSelected = this.critereRecherche.groupeIds;
        this.annonceursSelected = this.critereRecherche.annonceurs;
        this.payeursSelected = this.critereRecherche.payeurs;
        await this.loadParametresInterne([
          typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
          typesParametres.PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
          typesParametres.PARAMETRES_INTERNE_KEYS.medialinePlanningLCRenouvellement.key,
        ]);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>

<style scoped>

</style>
